export const quotesOrOpportunities = (match, location) => {
  return (
    location.pathname.match(/^\/opportunities/) ||
    location.pathname.match(/^\/quotes/)
  );
};

export const accounts = (match, location) => {
  return location.pathname.match(/^\/accounts/);
};

export const merchants = (match, location) => {
  return location.pathname.match(/^\/merchants/);
};
